import React, { useRef, useState } from "react";
import { Box, Button, SwipeableDrawer, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FilePond } from "react-filepond";
import CommonConstantValues from "../../Services/CommonConstantValues";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";

const useStyles = makeStyles({
  puller: {
    width: 50,
    height: 6,
    margin: "20px",
    top: 10,
    left: "calc(50% - 25px)",
    borderRadius: 3,
    backgroundColor: "#ddd",
  },
  filePond: {
    width: "100%",
    marginBottom: "90px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "50px",
  },
  fileUploadIcon: {
    display: "flex",
    padding: "17px",
    border: "1px solid #9d2123",
    borderRadius: "16px",
    background: "rgba(157, 33, 35, 0.15)",
    cursor: "pointer",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
  },
  uploadCtaContainer: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    maxWidth: "600px",
    background: "#9D2123",
    height: "50px",
    borderRadius: "0",
    color: "white",
    "&:hover": {
      backgroundColor: "#9D2123",
    },
  },
});
export default function FileUploadDrawer(props) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const pondFileRef = useRef(null);

  const handleUpdateFile = (file) => {
    if (
      file.fileSize <
      CommonConstantValues.MAX_FILE_SIZE_FOR_COMPLAINT_ATTACHMENT
    ) {
      setFiles((prevFiles) => [...prevFiles, file]);
    }
  };

  const handleRemoveFile = (error, file) => {
    console.log(file);
    console.log(file.id);
    setFiles((prevFiles) => {
      return _.filter(prevFiles, (childFile) => childFile.id !== file.id);
    });
  };

  const handleAddFile = () => {
    if (pondFileRef.current) {
      pondFileRef.current.browse();
    }
  };

  const handleClickAddAttachmentButton = (error, file) => {
    console.log(file?.value);
    handleUpdateFile(file);
  };

  const handleUploadBiltyClicked = () => {
    props.uploadBilty(files);
    setFiles([]);
    const clickedAddMoreProductEventData = {
      page: props.page,
      type: "Upload Bilty",
    };
    AnalyticsService.pushEvent(
      `Button Clicked`,
      clickedAddMoreProductEventData
    );
  };

  return (
    <SwipeableDrawer
      anchor={`bottom`}
      open={props.showFileUpload}
      disableDiscovery={true}
      disableSwipeToOpen={true}
      onOpen={() => AndroidService.unsetPullToRefresh()}
      onClose={(event) => {
        props.setShowFileUpload(false);
        AndroidService.setPullToRefresh();
      }}
      sx={{
        "& .MuiDrawer-paper": {
          borderTopLeftRadius: 30,
          borderTopRightRadius: 30,
        },
      }}
    >
      <Box className={classes.container}>
        <div className={classes.puller}></div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            sx={{ flex: "1", textAlign: "center", marginLeft: "44px" }}
          >
            Select files to upload
          </Typography>
          <img
            src="/icons/cross.svg"
            style={{
              alignSelf: "end",
              padding: "10px",
              marginRight: "10px",
            }}
            onClick={() => {
              setFiles([]);
              props.setShowFileUpload(false);
            }}
          />
        </Box>

        <Box
          className={`returnOrderCommentAttachmentUpload`}
          sx={{ width: "100%" }}
        >
          <FilePond
            ref={pondFileRef}
            files={files}
            allowFileSizeValidation={true}
            maxFileSize={
              CommonConstantValues.MAX_FILE_SIZE_FOR_COMPLAINT_ATTACHMENT
            }
            labelMaxFileSizeExceeded={"File is too large"}
            allowReorder={false}
            allowMultiple={true}
            allowImagePreview={false}
            onupdatefiles={handleUpdateFile}
            onremovefile={handleRemoveFile}
            onaddfile={handleClickAddAttachmentButton}
            labelMaxFileSize="Max file size is 10 MB"
            acceptedFileTypes={["image/*"]}
            maxFiles={1}
          />
        </Box>
        <Box
          className={classes.fileUploadIcon}
          onClick={() => {
            handleAddFile();
          }}
        >
          <CloudUploadIcon color="primary" />
          <Typography
            textAlign={"center"}
            color={"primary"}
            sx={{ fontSize: "12px", fontWeight: 700, mt: 0.5 }}
          >
            Select Here
          </Typography>
        </Box>

        <Button
          fullWidth
          className={classes.uploadCtaContainer}
          onClick={() => {
            handleUploadBiltyClicked();
          }}
          variant="contained"
          disabled={files.length === 0}
        >
          Upload
        </Button>
      </Box>
    </SwipeableDrawer>
  );
}
